import { render, staticRenderFns } from "./PartnerBankingDetailTable.vue?vue&type=template&id=f5de1570&"
import script from "./PartnerBankingDetailTable.vue?vue&type=script&lang=ts&"
export * from "./PartnerBankingDetailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports